import { Theme } from "@emotion/react";
import { mdsCommonTheme } from "../common";
import { MDSTextVariant } from "@/mds/components/text/text.types";

export const mdsThemeClassic: Theme = {
  ...mdsCommonTheme,

  fontSizes: {
    ...mdsCommonTheme.fontSizes,
    [MDSTextVariant.HeaderXl]: "20px",
    [MDSTextVariant.HeaderL]: "20px",
  },
  lineHeights: {
    ...mdsCommonTheme.lineHeights,
    [MDSTextVariant.HeaderXl]: "28px",
    [MDSTextVariant.HeaderL]: "28px",
  },

  colors: {
    ...mdsCommonTheme.colors,

    // Override with classic theme colors (using the original foundation colors)
    editor: {
      0: "#FFE8E6",
      100: "#FFB5AB",
      200: "#FF8170",
      300: "#FF5C45",
      400: "#FF361A",
      500: "#DB1A00",
    },

    text: {
      contrast: mdsCommonTheme.colors.grey.x900,
      danger: mdsCommonTheme.colors.red.x500,
      primary: mdsCommonTheme.colors.grey.x600,
      secondary: mdsCommonTheme.colors.grey.x500,
      tertiary: mdsCommonTheme.colors.grey.x500,
      onAccent: mdsCommonTheme.colors.grey.x0,
      link: {
        default: mdsCommonTheme.colors.grey.x500,
        hover: mdsCommonTheme.colors.grey.x500,
      },
      emphasis: mdsCommonTheme.colors.mblue.x500,
      positive: mdsCommonTheme.colors.green.x500,
      negative: mdsCommonTheme.colors.red.x500,
      editor: {
        metadata: mdsCommonTheme.colors.grey.x500,
      },
    },
    icon: {
      // primary: "#0000FF",
      // secondary: "#0000FF",
      // placeholder: "#0000FF",
      // onAccent: "#0000FF",
      // brand: "#0000FF",
      // selected: "#0000FF",
      // emphasis: "#0000FF",
      // danger: "#0000FF",
      primary: mdsCommonTheme.colors.grey.x700,
      secondary: mdsCommonTheme.colors.grey.x600,
      placeholder: mdsCommonTheme.colors.grey.x500,
      onAccent: mdsCommonTheme.colors.grey.x0,
      brand: mdsCommonTheme.colors.primary.x500,
      selected: mdsCommonTheme.colors.mblue.x500,
      emphasis: mdsCommonTheme.colors.mblue.x500,
      danger: mdsCommonTheme.colors.red.x500,
      onChromeInactive: mdsCommonTheme.colors.grey.x500,
    },
    surface: {
      chrome: "#FDFBFE", // Not part of the palette
      pane: mdsCommonTheme.colors.grey.x0,
      paneHeader: mdsCommonTheme.colors.grey.x25,
      headsUp: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      chat: "#FFFF00",
      menu: mdsCommonTheme.colors.grey.x0,
      modal: mdsCommonTheme.colors.grey.x0,
      popover: "#FFFF00",
      toast: "#FFFF00",
      preview: mdsCommonTheme.colors.grey.x0,
      previewHeader: mdsCommonTheme.colors.grey.x25,
      tooltip: "#FFFF00",
      overlay: {
        default: "rgba(0, 0, 0, 0.08)",
        onboarding: "rgba(0, 0, 0, 0.08)",
      },
      onboarding: mdsCommonTheme.colors.grey.x0,
      onboardingSubtle: mdsCommonTheme.colors.grey.x25,
    },
    border: {
      input: {
        default: {
          default: "#FFFF00",
          focused: "#FFFF00",
          danger: "#FF0000",
        },
        brand: {
          default: "#FFFF00",
          focused: "#FFFF00",
        },
        emphasis: {
          default: "#FFFF00",
          focused: "#FFFF00",
        },
      },
      button: {
        marketing: {
          default: "#FFFF00",
          hover: "#FFFF00",
        },
      },
      default: mdsCommonTheme.colors.grey.x50,
      hover: mdsCommonTheme.colors.grey.x100,
      onAccent: "#FFFF00",
      chrome: "#FFFF00",
      emphasis: "#FFFF00",
      surface: mdsCommonTheme.colors.grey.x50,
      ghost: mdsCommonTheme.colors.grey.x50,
    },
    background: {
      voice: {
        self: mdsCommonTheme.colors.mblue.x500,
        others: mdsCommonTheme.colors.mblue.x500,
      },
      button: {
        contrast: {
          default: mdsCommonTheme.colors.grey.x900,
          hover: mdsCommonTheme.colors.grey.x900,
        },
        default: {
          default: mdsCommonTheme.colors.grey.x0,
          hover: mdsCommonTheme.colors.grey.x25,
        },
        chip: {
          default: mdsCommonTheme.colors.grey.x0,
          hover: mdsCommonTheme.colors.grey.x25,
          selectedNegative: mdsCommonTheme.colors.red.x50,
          selectedPositive: mdsCommonTheme.colors.green.x500,
        },
        toggle: {
          default: mdsCommonTheme.colors.grey.x0,
          hover: mdsCommonTheme.colors.grey.x25,
          toggled: mdsCommonTheme.colors.mblue.x50,
          toggledHover: mdsCommonTheme.colors.mblue.x100,
        },
        onAccent: {
          default: "transparent",
          hover: `${mdsCommonTheme.colors.grey.x500}10`,
        },
        emphasis: {
          default: mdsCommonTheme.colors.mblue.x500,
          hover: mdsCommonTheme.colors.mblue.x600,
        },
        emphasisLight: {
          default: mdsCommonTheme.colors.mblue.x500,
          hover: mdsCommonTheme.colors.mblue.x600,
        },
        transparent: {
          default: "transparent",
          hover: mdsCommonTheme.colors.grey.x50,
        },
        navigation: {
          default: "#FFFF00",
          hover: "#FFFF00",
        },
        chrome: {
          default: mdsCommonTheme.colors.lilac.x50,
          hover: mdsCommonTheme.colors.lilac.x100,
        },
        subtle: {
          default: mdsCommonTheme.colors.grey.x50,
          hover: mdsCommonTheme.colors.grey.x100,
        },
        danger: {
          default: mdsCommonTheme.colors.grey.x0,
          hover: mdsCommonTheme.colors.red.x50,
        },
        dangerFilled: {
          default: mdsCommonTheme.colors.red.x500,
          hover: mdsCommonTheme.colors.red.x600,
        },
        brand: {
          default: "#FFFF00",
          hover: "#FFFF00",
        },
        tabBar: {
          active: mdsCommonTheme.colors.grey.x0,
          default: mdsCommonTheme.colors.grey.x25,
          hover: mdsCommonTheme.colors.grey.x50,
        },
        onChrome: {
          default: mdsCommonTheme.colors.grey.x0,
          hover: mdsCommonTheme.colors.grey.x25,
        },
        floatingIcon: {
          default: mdsCommonTheme.colors.grey.x0,
          hover: mdsCommonTheme.colors.grey.x25,
        },
        contrastAccent: {
          default: mdsCommonTheme.colors.grey.x900,
          hover: mdsCommonTheme.colors.grey.x900,
        },
      },
      list: {
        default: mdsCommonTheme.colors.grey.x0,
        hover: mdsCommonTheme.colors.grey.x25,
        selected: mdsCommonTheme.colors.grey.x25,
        deepsearch: mdsCommonTheme.colors.grey.x0,
      },
      menu: {
        default: mdsCommonTheme.colors.grey.x0,
        hover: mdsCommonTheme.colors.lilac.x50,
        selected: mdsCommonTheme.colors.grey.x100,
        emphasized: mdsCommonTheme.colors.mblue.x50,
      },
      input: {
        default: {
          default: mdsCommonTheme.colors.grey.x0,
          focused: mdsCommonTheme.colors.grey.x100,
        },
        chrome: {
          default: "#FFFF00",
          focused: "#FFFF00",
          hover: "#FFFF00",
        },
        onAccent: {
          default: "#FFFF00",
          focused: "#FFFF00",
        },
        inline: {
          default: "#FFFF00",
          hover: "#FFFF00",
          focused: "#FFFF00",
        },
      },
      message: {
        user: "#FFFF00",
        mem: "#FFFF00",
      },
      badge: {
        default: mdsCommonTheme.colors.grey.x200,
        emphasis: mdsCommonTheme.colors.mblue.x200,
        moreEmphasis: mdsCommonTheme.colors.mblue.x400,
        negative: mdsCommonTheme.colors.red.x400,
      },
      banner: {
        danger: mdsCommonTheme.colors.red.x50,
        emphasis: mdsCommonTheme.colors.mblue.x50,
        default: mdsCommonTheme.colors.grey.x25,
      },
      card: {
        emphasis: mdsCommonTheme.colors.mblue.x50,
        default: mdsCommonTheme.colors.grey.x0,
      },
      activeTab: mdsCommonTheme.colors.grey.x500,
      illustration: {
        default: "#FFFF00",
        onAccent: "#FFFF00",
        contrast: "#FFFF00",
      },
      diff: mdsCommonTheme.colors.mblue.x50,
      skeleton: {
        bg: "#e8e9ed",
        ends: "#e8e9ed",
        middle: "#f8f8fa",
      },
    },
  },
};
